import {
  Component,
  OnInit,
  Input,
  OnDestroy,
  AfterViewInit,
  ElementRef,
  ViewChildren,
  QueryList,
} from "@angular/core";
import { Location } from "@angular/common";
import { Router, ActivatedRoute } from "@angular/router";

import { ProjectService } from "@service/project.service";
import { AuthService } from "@service/auth.service";
import { CommentService } from "@service/comments.service";

import { Profile } from "src/models/Profile";
import { Comment } from "src/models/Comment";
import { fromEvent, Subscription, Observable } from "rxjs";
import { map, tap } from "rxjs/operators";
import { Events } from "@service/events.service";
import { UtilService } from "@service/util.service";

import { select, Store } from "@ngrx/store";
import {
  AppState,
  getShowPlansButton,
  loadData,
  getShowDocHistoryDropdown,
  getDocHistory,
} from "@app/store";
import { THIS_EXPR } from "@angular/compiler/src/output/output_ast";

export const ROLES = [
  { slug: "advisor", name: "Orientador" },
  { slug: "mentor", name: "Mentor" },
  { slug: "co-supervisor", name: "Coorientador" },
  { slug: "main_author", name: "Autor" },
  { slug: "author", name: "Autor" },
];

@Component({
  selector: "app-navbar",
  templateUrl: "./navbar.component.html",
  styleUrls: ["./navbar.component.scss"],
})
export class NavbarComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChildren("writingProgress") writingProgress: QueryList<ElementRef>;

  @Input() profile: Profile;
  projectOpen: boolean = false;

  titleProject: string;
  author: string;
  countComments: number = 0;
  comments: Array<Comment> = [];
  loading = false;
  showPlansButton$: Observable<boolean>;
  showDocHistoryDropdown$: Observable<boolean>;
  docHistory$: Observable<any[]>;
  editorLabelsStatus: any;

  private commentSubscription: Subscription = new Subscription();
  private subscription: Subscription = new Subscription();

  public voucher_expires_at: number = 0;

  public showFileDownloadButton: boolean = false;
  public canEvaluate: boolean = false;
  public setLabelVisible: boolean = false;

  percentage: number = 0;
  spinnerProgress: number = 0;

  constructor(
    private store: Store<AppState>,
    private authenticationService: AuthService,
    private projectService: ProjectService,
    private commentService: CommentService,
    private router: Router,
    private location: Location,
    private events: Events,
    private authService: AuthService,
    private utilService: UtilService
  ) {}

  ngOnInit() {
    this.showPlansButton$ = this.store.pipe(select(getShowPlansButton));
    this.showDocHistoryDropdown$ = this.store.pipe(
      select(getShowDocHistoryDropdown)
    );
    this.docHistory$ = this.store.pipe(select(getDocHistory));
    this.store.dispatch(loadData());
    this.canEvaluate = this.authService.canEvaluate();

    this.events.on("pdfSpinnerPercent").subscribe((value: number) => {
      this.spinnerProgress = value;
    });

    AuthService.profilePictureUpdated.subscribe((imgURL) => {
      this.profile.url_image = imgURL;
    });

    AuthService.profileUpdated.subscribe((user) => {
      this.profile = user;
    });

    Events.voucherDidCalculate.subscribe((voucher_expires_at) => {
      setTimeout(() => {
        this.voucher_expires_at = voucher_expires_at;
      }, 0);
    });

    this.router.events.subscribe((val: ActivatedRoute) => {
      const locationPath = this.location.path();
      if (
        locationPath.includes("/projects") &&
        !locationPath.includes("repositories")
      ) {
        this.projectOpen = true;
        this.titleProject = this.projectService.getName(); // aqui
        this.author = this.projectService.getAuthor();
      } else {
        this.projectOpen = false;
      }

      const isEditor = this.location.path().includes("/document/editor");

      this.showFileDownloadButton = isEditor;

      if (isEditor) {
        Events.editorStatusLabel.subscribe((status: any) => {
          this.editorLabelsStatus = this.translateStatus(status);
        });
      }
      Events.showEditorLabel.subscribe((status: boolean) => {
        this.setLabelVisible = status;
      });
    });

    ProjectService.percentageChanged.subscribe(() => {
      const projectId = this.getProjectId();
      this.projectService.getCycles(projectId).subscribe((cycles) => {
        const percentage = this.projectService.calcPercentage(cycles);
        this.percentage = percentage;
      });
    });
    // console.log(this.setLabelVisible);
    // console.log(this.editorLabelsStatus);
  }

  downloadDocx(): void {
    this.events.broadcast("downloadDocx", this.projectService.getName());
  }

  downloadPdf(): void {
    this.events.broadcast("downloadPdf", {
      confirmBack: false,
      projectName: this.projectService.getName(),
    });
  }
  getText(): string {
    return this.voucher_expires_at <= 0 ? 'Clique para RENOVAR' : 'Ver assinaturas';
  }

  private translateStatus(sta: string): string {
    return this.utilService.translateStatus(sta);
  }

  ngAfterViewInit() {
    const projectId = this.getProjectId();

    this.subscription.add(
      this.projectService.getCycle(projectId, 3).subscribe((res) => {
        this.editorLabelsStatus = this.translateStatus(res.writing.status);
      })
    );

    if (projectId) {
      setTimeout(() => {
        this.getCountComments(projectId);
      }, 0);
    }

    this.commentSubscription = CommentService.projectOpened.subscribe(
      (projectId) => this.getCountComments(projectId)
    );

    // setTimeout(() => {
    this.events.on("writingProgress").subscribe((res) => {
      this.writingProgress
        .toArray()
        .find(
          (label) =>
            // @ts-ignore
            label.nativeElement.control.defaultValue === res.writing.status
        )
        .nativeElement.classList.add("active");

      this.writingProgress.forEach((label) => {
        this.subscription.add(
          fromEvent(label.nativeElement, "click")
            .pipe(
              // @ts-ignore
              map((event) => event.target.control.defaultValue),
              tap((e) => console.log(e))
            )
            .subscribe((value) => {
              this.subscription.add(
                this.projectService
                  .updateProgress(this.getProjectId(), {
                    cycle: 3,
                    step: {
                      name: "writing",
                      status: value,
                    },
                  })
                  .subscribe(() => {
                    this.projectService.setNavbarPercentage();
                  })
              );
            })
        );
      });
    });
    // }, 1000);
  }

  showNotificationsDropdown() {
    if (this.authenticationService.user) {
      return (
        (this.authenticationService.getInvitationRole() === "author" ||
          this.authenticationService.getInvitationRole() === "main_author")
      );
    }

    return false;
  }

  getEnterProject() {
    return this.projectService.getEnterProject();
  }

  getComments($dropDownMenu: any) {
    this.comments = [];
    setTimeout(() => {
      if ($dropDownMenu.classList.contains("show")) {
        this.loading = true;
        const projectId = this.getProjectId();
        this.commentService
          .getByProject(projectId)
          .subscribe((comments: Array<Comment>) => {
            this.loading = false;
            this.comments = comments;
          });
        this.getCountComments(projectId);
      }
    }, 3);
  }

  private getProjectId(): number {
    const locationPath = this.location.path();
    if (!locationPath.includes("repositories")) {
      return Number(this.location.path().split("/")[2]);
    }
    return 0; // zero is considered false
  }

  getMessageAuthor(userComment: any): string {
    const participants = this.authenticationService.getParticipants();

    if (!participants.find((p) => p.name === userComment.name)) {
      return "autor";
    }

    const participantComment = participants.find(
      (p) => p.name === userComment.name
    );
    return ROLES.find(
      (r) => r.slug === participantComment.role
    ).name.toLowerCase();
  }

  attPlan() {
    this.router.navigate(["plans"]);
  }

  getCountComments(projectId: number) {
    this.loading = true;
    return this.commentService.count(projectId).subscribe((count: number) => {
      this.countComments = count;
    });
  }

  logout() {
    this.authenticationService.disconnect().subscribe(() => {
      this.authenticationService.logout();
    });
  }

  // canEvaluate() {
  //   return this.authService.canEvaluate();
  // }

  updateProgress() {
    this.subscription.add(
      this.projectService
        .updateProgress(this.getProjectId(), {
          cycle: 3,
          step: {
            name: "writing",
            status: "define",
          },
        })
        .subscribe(() => {
          this.projectService.setNavbarPercentage();
        })
    );
  }

  ngOnDestroy() {
    this.commentSubscription.unsubscribe();
    this.subscription.unsubscribe();
  }
}
